import { stopBot, allocationAmount } from "assets/icons";
import { PUBLISH_STATUS_VALUES } from "utils/constants";

export const options = (published) => [
  {
    key: "edit",
    title: published === PUBLISH_STATUS_VALUES.NOT_PUBLISHED ? "Edit" : "View",
  },
  {
    key: "clone",
    title: "Clone",
  },
  {
    key: "host",
    title: "Host",
  },
  {
    key: "delete",
    title: "Delete",
  },
];

export const startStrategyOptions = (status) => {
  if (status === "Paused" || status === "Active") {
    return [
      {
        key: "stop",
        title: "Stop Strategy",
        icon: <img src={stopBot} className="start-icon" />,
      },
      {
        key: "allocationAmount",
        title: "Allocation Amount",
        icon: <img src={allocationAmount} className="start-icon" />,
      },
      {
        key: "manageStrategies",
        title: "Manage Strategies",
        icon: <img src={allocationAmount} className="start-icon" />,
      },
    ];
  }
  return [];
};
